import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=5ea10a8f&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports